import {ScheduleState} from "../../../type/schedule-state";

interface Action {
    type: string;
    payload: {
        scheduleId: string;
    };
}

export const removeScheduleByIdDispatch = (
    state: ScheduleState,
    action: Action
) => {
    state.schedulePageAll = {
        ...state.schedulePageAll,
        contents: state.schedulePageAll.contents
            .filter(schedule => schedule.id !== action.payload.scheduleId),
    }
};
